// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/page-template/lgp/main.scss
// module id = 70
// module chunks = 4